import { ApiType } from 'utils/types'
import { apiAuthFetcher, apiFetcher } from './api'
import { hashPassword } from 'utils/auth/password'
import { sessionStorageEmailKey } from 'components/auth/register/handleSignupSuccess'
import { setSessionValue } from 'utils/sessionStorage'

export async function postRefresh(refreshToken: string) {
  return apiFetcher<ApiType['UserLoginResponse']>('/api/v1/auth/refresh', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${refreshToken}`,
    },
  })
}

export async function postLogout(refreshToken: string) {
  return apiFetcher<void>('/api/v1/auth/logout', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${refreshToken}`,
    },
  })
}

export async function postLogin(email: string, password: string) {
  setSessionValue(sessionStorageEmailKey, email)
  return apiFetcher<ApiType['PublicUserLoginResponse']>('/api/v1/auth/login', {
    method: 'POST',
    headers: {
      Authorization: `Basic ${btoa(`${email}:${await hashPassword(password)}`)}`,
    },
  })
}

export async function resendMfaLoginCode(mfaToken: string) {
  return apiFetcher<ApiType['PublicUserLoginResponse']>('/api/v1/user/mfa/resend', mfaToken, {
    method: 'POST',
    body: {
      old_mfa_token: mfaToken,
    } as ApiType['ResendMfaCodeRequest'],
  })
}

export async function postMfaLogin(code: string, mfaToken: string) {
  return apiFetcher<ApiType['PublicUserLoginResponse']>('/api/v1/auth/login/mfa', mfaToken, {
    method: 'POST',
    body: { code },
  })
}

export async function postRegister(email: string, password: string) {
  return apiFetcher<ApiType['PublicUserLoginResponse']>('/api/v1/auth/login', {
    method: 'POST',
    headers: {
      Authorization: `Basic ${btoa(`${email}:${await hashPassword(password)}`)}`,
    },
  })
}

export async function postUserVerification(body: ApiType['UserMfaVerifyRequest']) {
  return apiAuthFetcher<ApiType['VerificationTokenResponse']>('/api/v1/auth/verify', {
    method: 'POST',
    body,
  })
}

export function postAuthTokenCheck(body: ApiType['CheckSignupTokenRequest']) {
  return apiFetcher<ApiType['PublicSignupTokenCheckResponse']>(`/api/v1/auth/signup-token/check`, {
    method: 'POST',
    body,
  })
}

export function postAuthTokenProcess(body: ApiType['ProcessSignupTokenRequest']) {
  return apiFetcher<unknown>(`/api/v1/auth/signup-token`, {
    method: 'POST',
    body,
  })
}
